export const isPayinLocked = (booking) => {
  if (!booking?.payin_pending_until) return false;
  const ts = Date.parse(booking.payin_pending_until);
  return Number.isFinite(ts) && ts > Date.now();
};
